import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getSubcontractorEmployeeData = async (
  projectId,
  activeEmployerInfo
) => {
  const apiPath = `workflow/init/project/${projectId}/subcontractor-employee-data`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
